/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agents_Resources_HintInputs */

const en_directory_agents_resources_hint = /** @type {(inputs: Directory_Agents_Resources_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everything an agent or an engineer needs, in four links.`)
};

const zh_directory_agents_resources_hint = /** @type {(inputs: Directory_Agents_Resources_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`agent 和工程师需要的一切，四个链接。`)
};

/**
* | output |
* | --- |
* | "Everything an agent or an engineer needs, in four links." |
*
* @param {Directory_Agents_Resources_HintInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agents_resources_hint = /** @type {((inputs?: Directory_Agents_Resources_HintInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agents_Resources_HintInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agents_resources_hint(inputs)
	return zh_directory_agents_resources_hint(inputs)
});
export { directory_agents_resources_hint as "directory.agents.resources_hint" }